import { unByKey } from 'ol/Observable';

import { DrawInteraction } from 'cadenza/map/interactions/draw-interaction';
import { cloneStyle } from 'cadenza/map/style/style-util';

export class CommonDrawInteraction extends DrawInteraction {

  #item;
  #featureStyle;

  constructor (options, map, paletteItem) {
    super(options, map);
    this.#item = paletteItem;
    this.#featureStyle = options.featureStyle;
    this.on('change:active', event => {
      if (!event.oldValue) {
        this._onActivation();
      } else {
        this._onDeactivation();
      }
    });
  }

  _onActivation () {
    this._eventKeys.push(
      this.on('drawstart', event => this._onDrawStart(event))
    );
  }

  _onDeactivation () {
    unByKey(this._eventKeys);
  }

  _onDrawStart (event) {
    event.feature.type = this.#item.type;
    event.feature.setStyle(cloneStyle(this.#featureStyle));
  }

}
